import axios from 'axios';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

// CM Assignment (Nic 2026-10-09): Ready for CM clients to their Claims
// Manager.

const BASE = '/cm-assignment';
const KEY = ['cm-assignment'];

// One page of the queue (25), searched on the server (2026-10-13). tab:
// ready (Ready for CM) | ptrs (Waiting on PTRs, assignable early; 2026-10-26)
// | one (Waiting on one item, read only; 2026-10-28) | training (For
// Training, reserved for a Claims Manager In Training; 2026-10-30).
// sort / dir (Nic 2026-11-02): a column sort (name | rating | waiting, asc |
// desc), applied on the server because the queue pages there.
export const useCmQueue = ({ page = 1, q = '', tab = 'ready', sort = null, dir = 'desc' } = {}) =>
  useQuery(
    [...KEY, 'queue', tab, page, q, sort || null, sort ? dir : null],
    async () =>
      (await axios.get(BASE, { params: { page, q: q || undefined, tab, sort: sort || undefined, dir: sort ? dir : undefined } })).data,
    {
    keepPreviousData: true,
    refetchInterval: 30000,
    refetchOnWindowFocus: true,
  });

export const useRecentCmMoves = (enabled) =>
  useQuery([...KEY, 'recent'], async () => (await axios.get(`${BASE}/recent`)).data, {
    enabled: !!enabled,
    refetchOnWindowFocus: true,
  });

// quiet (2026-10-28): the page assigns several at once and refreshes the
// list itself, once, when all are done, so rows leave together instead of
// one by one.
// For Training (2026-10-30): reserve a Ready client for a Claims Manager In
// Training (on), or put them back on Ready (off). quiet as above.
export const useSetTrainingMark = ({ quiet = false } = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    async ({ onboardingId, on }) =>
      (on
        ? await axios.post(`${BASE}/${onboardingId}/training`)
        : await axios.delete(`${BASE}/${onboardingId}/training`)
      ).data,
    {
      onSuccess: () => {
        if (quiet) return;
        queryClient.invalidateQueries(KEY);
        queryClient.invalidateQueries(['client-onboarding']);
      },
    },
  );
};

export const useAssignCm = ({ quiet = false } = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    async ({ onboardingId, claimsManagerUserId }) =>
      (await axios.post(`${BASE}/${onboardingId}/assign`, { claimsManagerUserId })).data,
    {
      onSuccess: () => {
        if (quiet) return;
        queryClient.invalidateQueries(KEY);
        queryClient.invalidateQueries(['client-onboarding']);
      },
    },
  );
};
